(function() { window.GUID_8ab7aee1_5678_49bc_90ea_93299ae8fc23 = { getGuid: function() { return "8ab7aee1-5678-49bc-90ea-93299ae8fc23"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-resultsofpersona ",
                        callback: (accordion, e) => {
                            accordion.$Content.offon("click.accordionResultsofpersonaTabMenuClicked", `#tabmenu-resultsofpersona-${accordion.ContentId}`, (e) => {
                                const $closestTabMenuItem = $(e.target).closest(".tab-menu-item");
                                if ($closestTabMenuItem.length) {
                                    const { popupUrl } = $closestTabMenuItem.data("html");
                                    if (popupUrl) {
                                        accordion.RefreshContent(() => { }, popupUrl);
                                    }
                                }
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=results-of-persona.js.map
